import styled, { css } from 'styled-components';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { TOP_CONTAINER_WIDTH } from './model/configs';

export const TopContainer = styled.div<{ $isMobileOnly?: boolean }>`
  width: ${TOP_CONTAINER_WIDTH}px;
  margin: 24px auto 0;

  min-height: 200px;
  overflow: hidden;
  display: flex;
  position: relative;
  white-space: nowrap;

  flex-direction: row;
  gap: 10px;

  max-width: 100%;

  @media (max-width: 768px) {
    margin-top: 16px;
    overflow: auto;
    width: 100%;

    ${brandIsPh &&
    css`
      margin-top: 12px;
    `}
  }

  ${({ $isMobileOnly }) =>
    $isMobileOnly &&
    `
    overflow: auto;
  `}
`;
